import React, { Suspense } from "react";
import { Switch, Route, BrowserRouter } from "react-router-dom";
import Loader from "../app/loader";
import Footer from "../app/layouts/footer";
import PrivateRoute from "./PrivateRoute";
import BootomNav from "../app/layouts/bootomNav";
import { connect } from "react-redux";
import Store from "../redux/store";
import { setCurrentUser } from "../redux/actions/authAction";
import { useWidthAndHeight } from "../hooks/useWidthAndHeight";

const Home = React.lazy(() => import("../app/pages/Home"));
const Discover = React.lazy(() => import("../app/pages/Discover"));
const Blogs = React.lazy(() => import("../app/pages/Blogs"));
const BlogDetailPage = React.lazy(() => import("../app/pages/Blogs/Details"));
const HomeAuthenticated = React.lazy(() => import("../app/pages/HomeAuth"));
const ChatSection = React.lazy(() => import("../app/pages/ChatPage"));
const EventLive = React.lazy(() => import("../app/pages/Events/Live"));
const EventUpcoming = React.lazy(() => import("../app/pages/Events/Upcoming"));
const EventUsers = React.lazy(() => import("../app/pages/Events/User"));
const Settings = React.lazy(() => import("../app/pages/Settings"));
const Interactions = React.lazy(() => import("../app/pages/Interactions"));
const Notification = React.lazy(() => import("../app/pages/Notification"));
const StudentProfile = React.lazy(() =>
  import("../app/pages/Profiles/Student")
);
const TeacherProfile = React.lazy(() =>
  import("../app/pages/Profiles/Teacher")
);
// Check for token to keep user logged in
if (localStorage.token) {
  // Decode token and get user info
  const user = JSON.parse(localStorage.user);
  // Set user and isAuthenticated
  Store.dispatch(setCurrentUser(user));
}

const App = (props) => {
  const [width] = useWidthAndHeight();

  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route exact path={["/home", "/"]} component={Home} />
          <Route exact path={"/discover"} component={Discover} />
          <Route exact path={"/blogs"} component={Blogs} />
          <Route exact path={"/blogs/:id"} component={BlogDetailPage} />
          <PrivateRoute
            exact
            path={"/auth/home"}
            component={HomeAuthenticated}
          />
          <PrivateRoute exact path={"/users"} component={HomeAuthenticated} />
          <PrivateRoute exact path={"/messages"} component={ChatSection} />
          <PrivateRoute
            exact
            path={"/notifications"}
            component={Notification}
          />
          <PrivateRoute exact path={"/event/user"} component={EventUsers} />
          <PrivateRoute exact path={"/event/live"} component={EventLive} />
          <PrivateRoute
            exact
            path={"/event/upcoming"}
            component={EventUpcoming}
          />
          <PrivateRoute exact path={"/settings"} component={Settings} />
          <PrivateRoute exact path={"/interactions"} component={Interactions} />
          <PrivateRoute
            exact
            path={"/profile/student"}
            component={StudentProfile}
          />
          <PrivateRoute
            exact
            path={"/profile/teacher"}
            component={TeacherProfile}
          />
        </Switch>
        <Footer />
        {/* bottom navigation bar only visible after user login */}
        {props.auth.isAuthenticated && <BootomNav width={width} />}
      </Suspense>
    </BrowserRouter>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, null)(App);
